import { AppShell } from '@mantine/core';
import { createAccountTransactionRegistry } from 'entities/transaction';
import { accountsTransactionPageModel } from '../../model';
import cls from './accounts-transaction-page.module.scss';

export const AccountTransactionRegistry = createAccountTransactionRegistry(
	accountsTransactionPageModel.accountTransactionRegistryModel,
);

export const AccountsTransactionPage = () => (
	<AppShell.Main className={cls.accountsTransactionPage}>
		<AccountTransactionRegistry />
	</AppShell.Main>
);
